<template>
  <header class="header">
    <div class="header__inner container">
      <RouterLink to="/" class="header__logo" data-testid="logo">
        <img
          src="/images/about/logo-hp-sm.webp"
          alt="Happy Protection"
          width="32"
          height="32"
        />
      </RouterLink>

      <button
        class="header__hamburger"
        data-testid="hamburger"
        :aria-expanded="menuOpen.toString()"
        aria-controls="main-nav"
        aria-label="Ouvrir le menu de navigation"
        @click="menuOpen = !menuOpen"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav id="main-nav" class="header__nav" :class="{ 'header__nav--open': menuOpen }" aria-label="Navigation principale">
        <RouterLink to="/" @click="menuOpen = false">Accueil</RouterLink>
        <RouterLink to="/services" @click="menuOpen = false">Nos services</RouterLink>
        <RouterLink to="/zones-intervention" @click="menuOpen = false">Zones d'intervention</RouterLink>
        <RouterLink to="/a-propos" @click="menuOpen = false">À propos</RouterLink>
        <RouterLink to="/recrutement" @click="menuOpen = false">Recrutement</RouterLink>
        <RouterLink to="/devis" class="header__cta" @click="menuOpen = false">Devis</RouterLink>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from 'vue'

const menuOpen = ref(false)

const handleKeydown = (e) => {
  if (e.key === 'Escape' && menuOpen.value) {
    menuOpen.value = false
  }
}

onMounted(() => document.addEventListener('keydown', handleKeydown))
onUnmounted(() => document.removeEventListener('keydown', handleKeydown))
</script>

<style scoped>
.header {
  position: sticky;
  top: 0;
  z-index: 100;
  background-color: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  border-bottom: 1px solid rgba(226, 232, 240, 0.15);
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.05);
}

.header__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block: 0.5rem;
  min-height: 64px;
}

.header__logo img {
  display: block;
  width: 32px;
  height: 32px;
  object-fit: contain;
}

/* Nav — desktop */
.header__nav {
  display: flex;
  align-items: center;
  gap: 2rem;
}

.header__nav a {
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: var(--text-base);
  color: var(--color-text);
  text-transform: uppercase;
  letter-spacing: -0.025em;
  white-space: nowrap;
  transition: color 0.2s;
}

.header__nav a:hover {
  color: var(--color-accent);
}

.header__nav a.router-link-active:not(.header__cta) {
  color: #0369a1;
  border-bottom: 2px solid #0369a1;
}

/* CTA button */
.header__cta {
  background-color: var(--color-accent) !important;
  color: var(--color-white) !important;
  font-size: var(--text-tag) !important;
  letter-spacing: 0.0625em !important;
  padding: 0.5rem 1.5rem;
  border-radius: 2px;
  border-bottom: none !important;
}

.header__cta:hover {
  opacity: 0.9;
}

/* Hamburger — hidden on desktop */
.header__hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  padding: 0.5rem;
}

.header__hamburger span {
  display: block;
  width: 24px;
  height: 2px;
  background-color: var(--color-heading);
  transition: transform 0.2s;
}

/* Mobile */
@media (max-width: 767px) {
  .header__hamburger {
    display: flex;
  }

  .header__nav {
    display: none;
    position: absolute;
    top: 64px;
    left: 0;
    right: 0;
    flex-direction: column;
    align-items: flex-start;
    background-color: var(--color-white);
    padding: 1.5rem;
    gap: 1rem;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  .header__nav--open {
    display: flex;
  }

  .header__nav a.router-link-active:not(.header__cta) {
    padding-bottom: 0;
    border-bottom: none;
  }

  .header__cta {
    width: 100%;
    text-align: center;
    padding: 0.75rem 1.5rem !important;
  }
}
</style>
